import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { LEFT_SIDEBAR_WIDTH, RIGHT_SIDEBAR_WIDTH } from './const';

export interface SidebarMenuWrapperProps {
  isPageBodyMenu?: boolean;
  isRightContent?: boolean;
  isResizable?: boolean;
  isFullWidth?: boolean;
}

type SidebarMenuWrapperStyledProps = {
  $isPageBodyMenu?: boolean;
  $isRightContent?: boolean;
  $isResizable?: boolean;
  $isFullWidth?: boolean;
};

export const SidebarMenuWrapper = styled.form<SidebarMenuWrapperStyledProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  background-color: ${colors.surfaceDefault};
  border: 1px solid ${colors.borderSubtle};
  border-bottom: none;
  ${({ $isPageBodyMenu, $isRightContent, $isResizable, $isFullWidth }) =>
    $isPageBodyMenu &&
    css`
      ${$isResizable ? 'width' : 'max-width'}: ${
        $isFullWidth
          ? '100%'
          : `${$isRightContent ? RIGHT_SIDEBAR_WIDTH : LEFT_SIDEBAR_WIDTH}px`
      };
    `}
`;

export const SIDEBAR_MENU_SELECTOR = SidebarMenuWrapper.toString();
